module.exports = __webpack_public_path__ + "img/744.2c0ce650.jpg";